var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.52 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M2.52 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M2.52 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.bda26daeaea17a4292620504bb393452.svg";
export { ForwardRef as ReactComponent };